var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var Codec = require('./crypto/codec');

var Signature = require('./crypto/signature');

var sha3 = require('sha3');

var KeyPair = require('./crypto/key_pair');

var Tx =
/*#__PURE__*/
function () {
  "use strict";

  function Tx(gasRatio, gasLimit) {
    _classCallCheck(this, Tx);

    this.gasRatio = gasRatio;
    this.gasLimit = parseInt(gasLimit);
    this.actions = [];
    this.signers = [];
    this.signatures = [];
    this.publisher = "";
    this.publisher_sigs = [];
    this.amount_limit = [];
    this.chain_id = 1024;
    this.reserved = null;
  }

  _createClass(Tx, [{
    key: "setChainID",
    value: function setChainID(id) {
      this.chain_id = id;
    }
  }, {
    key: "addSigner",
    value: function addSigner(name, permission) {
      this.signers.push(name + "@" + permission);
    }
  }, {
    key: "addApprove",
    value: function addApprove(token, amount) {
      this.amount_limit.push({
        token: token,
        value: amount
      });
    }
  }, {
    key: "addAction",
    value: function addAction(contract, abi, args) {
      this.actions.push({
        contract: contract,
        actionName: abi,
        data: args
      });
    }
  }, {
    key: "setTime",
    value: function setTime(expirationInSecound, delay, serverTimeDiff) {
      var date = new Date();
      this.time = date.getTime() * 1e6 + serverTimeDiff;
      this.expiration = this.time + expirationInSecound * 1e9;
      this.delay = delay;
    }
  }, {
    key: "setGas",
    value: function setGas(gasRatio, gasLimit) {
      if (typeof gasLimit !== 'number' || gasLimit > 4000000 || gasLimit < 6000) {
        throw "gas limit should be in [6000, 4000000]";
      }

      if (typeof gasRatio !== 'number' || gasRatio < 1 || gasRatio > 100) {
        throw "gas limit should be in [1, 100]";
      }

      this.gasLimit = gasLimit;
      this.gasRatio = gasRatio;
    }
  }, {
    key: "_base_hash",
    value: function _base_hash() {
      var hash = sha3.SHA3(256);
      hash.update(this._bytes(0));
      return hash.digest("binary");
    }
  }, {
    key: "addSign",
    value: function addSign(kp) {
      var sig = new Signature(this._base_hash(), kp);
      this.signatures.push(sig);
    }
  }, {
    key: "_publish_hash",
    value: function _publish_hash() {
      var hash = sha3.SHA3(256);
      hash.update(this._bytes(1));
      return hash.digest("binary");
    }
  }, {
    key: "addPublishSign",
    value: function addPublishSign(publisher, kp) {
      this.publisher = publisher;

      var info = this._publish_hash();

      var sig = new Signature(info, kp);
      this.publisher_sigs.push(sig);
    }
  }, {
    key: "_bytes",
    value: function _bytes(n) {
      var c = new Codec();
      c.pushInt64(this.time);
      c.pushInt64(this.expiration);
      c.pushInt64(parseInt(this.gasRatio * 100));
      c.pushInt64(this.gasLimit * 100);
      c.pushInt64(this.delay);
      c.pushInt(this.chain_id);

      if (!this.reserved) {
        c.pushInt(0);
      }

      c.pushInt(this.signers.length);

      for (var i = 0; i < this.signers.length; i++) {
        c.pushString(this.signers[i]);
      }

      c.pushInt(this.actions.length);

      for (var _i = 0; _i < this.actions.length; _i++) {
        var c2 = new Codec();
        c2.pushString(this.actions[_i].contract);
        c2.pushString(this.actions[_i].actionName);
        c2.pushString(this.actions[_i].data);
        c.pushBytes(c2._buf);
      }

      c.pushInt(this.amount_limit.length);

      for (var _i2 = 0; _i2 < this.amount_limit.length; _i2++) {
        var _c = new Codec();

        _c.pushString(this.amount_limit[_i2].token);

        _c.pushString(this.amount_limit[_i2].value + "");

        c.pushBytes(_c._buf);
      }

      if (n > 0) {
        c.pushInt(this.signatures.length);

        for (var _i3 = 0; _i3 < this.signatures.length; _i3++) {
          c.pushBytes(this.signatures[_i3]._bytes());
        }
      }

      if (n > 1) {// todo
      }

      return c._buf;
    }
  }]);

  return Tx;
}();

module.exports = {
  Tx: Tx
};